<div class="row">
  <div class="col-12">
    <div class="content-header">Employee Form</div>
  </div>
</div>
<!-- Basic Inputs start -->
<section id="basic-input">
  <div class="row">
    <div class="col-12">
      <div class="card">
        <div class="card-content">
          <div class="card-body">
            <div class="row">
              <div class="col-md-6">
                <form [formGroup]="employeeForm">
                  <fieldset class="form-group">
                    <label for="name">Name<span class="required_field">*</span></label>
                    <input
                      type="text"
                      class="form-control"
                      formControlName="name"
                      [(ngModel)]="employee.name"
                      id="name"
                      placeholder="Enter Name"
                      [ngClass]="{
                        'is-invalid': employeeFormSubmitted && rf.name.invalid,
                        'is-valid': employeeFormSubmitted && !rf.name.invalid
                      }"
                      required
                      #name
                    />
                    <div
                        *ngIf="
                        rf.name.touched &&
                          (rf.name.invalid ||
                            rf.name.errors?.required)
                        "
                        class="help-block mt-1 text-danger"
                      >
                        <i class="ft-alert-circle align-middle"></i> Name
                        is required
                      </div>
                  </fieldset>
                  <fieldset class="form-group" *ngIf="!employee.email">
                    <label>Email<span class="required_field">*</span></label>
                    <input
                      type="email"
                      class="form-control"
                      formControlName="email"
                      id="email"
                      placeholder="Enter email"
                      [ngClass]="{
                        'is-invalid': employeeFormSubmitted && rf.email.invalid,
                        'is-valid': employeeFormSubmitted && !rf.email.invalid
                      }"
                      required
                      #email
                    />
                    <small
                      class="form-text text-muted danger"
                      *ngIf="
                        rf.email.touched &&
                          (rf.email.invalid ||
                            rf.email.errors?.required)
                        "
                      >Please enter a valid email!</small
                    >
                  </fieldset>
                  <fieldset class="form-group" *ngIf="employee.email">
                    <label>Email<span class="required_field">*</span></label>
                    <input
                      type="email"
                      class="form-control"
                      formControlName="email"
                      [(ngModel)]="employee.email"
                      id="email"
                      placeholder="Enter email"
                      [ngClass]="{
                        'is-invalid': employeeFormSubmitted && rf.email.invalid,
                        'is-valid': employeeFormSubmitted && !rf.email.invalid
                      }"
                      
                      #email
                    />
                    <small
                      class="form-text text-muted danger"
                      *ngIf="!email.valid && (email.dirty || email.touched)"
                      >Please enter a valid email!</small
                    >
                  </fieldset>
                  <fieldset class="form-group">
                    <label for="phone">Phone<span class="required_field">*</span></label>
                    <input
                      placeholder="e.g. 1234-567-890"
                      mask="0000-000-000"
                      minlength="10"
                      type="text"
                      class="form-control"
                      formControlName="phone"
                      [(ngModel)]="employee.phone"
                      id="phone"
                      #phone
                    />
                  </fieldset>
                  <fieldset *ngIf="!emp_id" class="form-group">
                    <label for="location">Location</label>
                    <input
                      type="text"
                      (keydown.enter)="$event.preventDefault()"
                      autocorrect="off"
                      autocapitalize="off"
                      spellcheck="off"
                      class="form-control"
                      formControlName="location"
                      id="location"
                      placeholder="Enter location"
                    #search/> 
                  </fieldset>
                  <fieldset *ngIf="emp_id" class="form-group">
                    <label for="location">Location</label>
                    <input
                      type="text"
                      (keydown.enter)="$event.preventDefault()"
                      autocorrect="off"
                      autocapitalize="off"
                      spellcheck="off"
                      class="form-control"
                      [(ngModel)]="employee.address"
                      [ngModelOptions]="{standalone: true}"
                      id="location"
                      placeholder="Enter location"
                    #search/> 

                  </fieldset>
                  
                  <fieldset class="form-group">
                    <label for="empcode">Empcode</label>
                    <input
                      type="text"
                      class="form-control"
                      formControlName="empcode"
                      [(ngModel)]="employee.empcode"
                      id="empcode"
                      placeholder="Enter empcode"
                      #empcode
                    />
                  </fieldset>
                  <fieldset class="form-group">
                    <label class="form-control-label" for="Employeetype">
                      Employee Type
                    </label>
                    <ng-select
                      [items]="typeList"
                      bindLabel="displayname"
                      bindValue="_id"
                      placeholder="Select  Employee Type"
                      [multiple]="true"
                      [(ngModel)]="selectType"
                      [ngModelOptions]="{ standalone: true }"
                      (change)="getTypeId($event)"
                    >
                    </ng-select>
                  </fieldset>
                  <!-- <fieldset class="form-group">
                    <label for="employeetype">Employeetype </label>
                    <input
                      type="text"
                      class="form-control"
                      formControlName="employeetype"
                      [(ngModel)]="employee.employeetype"
                      id="employeetype"
                      placeholder="Enter employeetype"
                      #employeetype
                    />
                  </fieldset> -->
<!-- 
                  <fieldset class="form-group">
                    <label for="address">Address </label>
                    <input
                      type="text"
                      class="form-control"
                      formControlName="address"
                      [(ngModel)]="employee.address"
                      id="address"
                      placeholder="Enter address"
                      #address
                    />
                  </fieldset> -->
                  <fieldset class="form-group">
                    <label for="gender">Gender </label>
                    <ng-select
                      [items]="genderList"
                      bindLabel="name"
                      bindValue="id"
                      placeholder="Select gender"
                      [(ngModel)]="selected_gender"
                      [ngModelOptions]="{ standalone: true }"
                      (change)="getGenderId($event)"
                    >
                    </ng-select>
                  
                  </fieldset>

                  <fieldset class="form-group">
                    <label for="marriagestatus">Marriage Status </label>
                    <input
                      type="text"
                      class="form-control"
                      formControlName="marriagestatus"
                      [(ngModel)]="employee.marriagestatus"
                      id="marriagestatus"
                      placeholder="Enter marriage status"
                      #marriagestatus
                    />
                  </fieldset>
                  <fieldset class="form-group">
                    <label for="fathername">Father Name </label>
                    <input
                      type="text"
                      class="form-control"
                      formControlName="fathername"
                      [(ngModel)]="employee.fathername"
                      id="fathername"
                      placeholder="Enter father name"
                      #fathername
                    />
                  </fieldset>
                  <fieldset class="form-group">
                    <label for="mothername">Mother Name </label>
                    <input
                      type="text"
                      class="form-control"
                      formControlName="mothername"
                      [(ngModel)]="employee.mothername"
                      id="mothername"
                      placeholder="Enter mother name"
                      #mothername
                    />
                  </fieldset>
                  <fieldset class="form-group">
                    <label for="salary">Salary </label>
                    <input
                      type="text"
                      class="form-control"
                      formControlName="salary"
                      [(ngModel)]="employee.salary"
                      id="salary"
                      placeholder="Enter salary"
                      #salary
                    />
                  </fieldset>
                  <fieldset class="form-group">
                    <label for="dob">Date Of Birth </label>
                    <input
                      type="date"
                      class="form-control"
                      formControlName="dob"
                      [(ngModel)]="employee.dob"
                      id="dob"
                      placeholder="Enter Dob"
                      #dob
                    />
                  </fieldset>
                  <fieldset class="form-group">
                    <label for="designation">Designation </label>
                    <input
                      type="text"
                      class="form-control"
                      formControlName="designation"
                      [(ngModel)]="employee.designation"
                      id="designation"
                      placeholder="Enter designation"
                      #designation
                    />
                  </fieldset>
                  <fieldset class="form-group">
                    <label>Qualification </label>
                    <input
                      type="text"
                      class="form-control"
                      formControlName="qualification"
                      [(ngModel)]=" employee.qualification"
                      id="qualification"
                      placeholder="Enter Qualification"
                    />
                  </fieldset>
                  <fieldset class="form-group">
                    <label class="form-control-label" for="Employeetype">
                     Skills
                    </label>
                    <ng-select
                      [items]="tagsList"
                      bindLabel="displayname"
                      bindValue="_id"
                      #skills="ngModel"
                      [multiple]="true"
                      [closeOnSelect]="false"
                      placeholder="Select Skill"
                      [(ngModel)]="selected_skillTag"
                      [ngModelOptions]="{ standalone: true }"
                      (change)="getTagsId($event)">
                    </ng-select>
                  </fieldset>
                  <fieldset class="form-group">
                    <label class="form-control-label mb-1">Refrence</label>
                      <ng-select [items]="users_List" bindLabel="name" bindValue="_id" placeholder="Select Refrence"
                        [(ngModel)]="select_refrence" [ngModelOptions]="{standalone: true}" (change)="getRefrenceId($event)">
                      </ng-select>
                  </fieldset>
                </form>
              </div>
              <div class="col-md-6">
                <form [formGroup]="employeeForm">
                  <fieldset class="form-group">
                    <label for="pan">Pan </label>
                    <input
                      type="text"
                      class="form-control"
                      formControlName="pan"
                      [(ngModel)]="employee.pan"
                      id="pan"
                      placeholder="Enter pan"
                      #pan
                    />
                  </fieldset>
                  <fieldset class="form-group">
                    <label for="accountno">Account Number </label>
                    <input
                      type="number" min="1" max="10"
                      class="form-control"
                      formControlName="accountno"
                      [(ngModel)]="employee.accountno"
                      id="accountno"
                      placeholder="Enter account number"
                      #accountno
                    />
                  </fieldset>
                  <fieldset class="form-group">
                    <label for="linkedIn"> Linked-In </label>
                    <input
                      type="text"
                      class="form-control"
                      formControlName="linkedIn"
                      [(ngModel)]="employee.linkedIn"
                      id="linkedIn"
                      placeholder="Enter Linked-In"
                      #linkedIn
                    />
                  </fieldset>

                  <fieldset class="form-group">
                    <label for="previousemployement"
                      >Previous Employement
                    </label>
                    <textarea
                      rows="1"
                      type="text"
                      class="form-control"
                      formControlName="previousemployement"
                      [(ngModel)]="employee.previousemployement"
                      id="previousemployement"
                      placeholder="Enter Previous Employement"
                    ></textarea>
                  </fieldset>
                 
                  <fieldset class="form-group">
                    <label for="dateofjoining">Date Of Joining </label>
                    <input
                      type="date"
                      class="form-control"
                      formControlName="dateofjoining"
                      [(ngModel)]="employee.dateofjoining"
                      id="dateofjoining"
                      placeholder="Enter Date Of Joining"
                      #dateofjoining
                    />
                  </fieldset>
                  <fieldset class="form-group">
                    <label for="dateofrelieving">Date Of Relieving </label>
                    <input
                      type="date"
                      class="form-control"
                      formControlName="dateofrelieving"
                      [(ngModel)]="employee.dateofrelieving"
                      id="dateofrelieving"
                      placeholder="Enter Date Of Relieving"
                      #dateofrelieving
                    />
                  </fieldset>
                  <fieldset class="form-group">
                    <label for="documents"> Documents </label>
                    <textarea
                      rows="1"
                      type="text"
                      class="form-control"
                      formControlName="documents"
                      [(ngModel)]="employee.documents"
                      id="documents"
                      placeholder="Enter  Documents"
                      #documents
                    ></textarea>
                  </fieldset>
                  <fieldset class="form-group">
                    <label class="form-control-label" for="badges"> Team</label>
                    <ng-select
                      [items]="teamList"
                      bindLabel="displayname"
                      bindValue="_id"
                      placeholder="Select Team"
                      [multiple]="true"
                      [(ngModel)]="selectTeam"
                      [ngModelOptions]="{ standalone: true }"
                      (change)="getTeamId($event)"
                    >
                    </ng-select>
                  </fieldset>
                  <fieldset class="form-group">
                      <label class="form-control-label" for="date">Technology</label>
                      <ng-select
                          [items]="technology_List"
                          bindLabel="displayname"
                          bindValue="_id"
                          placeholder="Select Technology"
                          [multiple]="true"
                          [(ngModel)]="selectedTechnology"
                          [ngModelOptions]="{ standalone: true }"
                          (change)="getTechnologyId($event)"> 
                      </ng-select>
                  </fieldset>
                  <fieldset class="form-group">
                    <label class="form-control-label" for="date">Report To</label>
                    <ng-select
                        [items]="users_List"
                        bindLabel="name"
                        bindValue="_id"
                        placeholder="Select"
                        [multiple]="true"
                        [(ngModel)]="selected_reportTo"
                        [ngModelOptions]="{ standalone: true }"
                        (change)="getReportToId($event)"> 
                    </ng-select>
                </fieldset>
                  <fieldset class="form-group">
                    <label for="responsibilities"> Responsibilities </label>
                    <textarea
                      rows="1"
                      type="text"
                      class="form-control"
                      formControlName="responsibilities"
                      [(ngModel)]="employee.responsibilities"
                      id="responsibilities"
                      placeholder="Enter  Responsibilities"
                      #responsibilities
                    ></textarea>
                  </fieldset>
                  <fieldset class="form-group">
                    <label> Guidelines </label>
                    <textarea
                      rows="1"
                      type="text"
                      class="form-control"
                      formControlName="guidelines"
                      [(ngModel)]="employee.guidelines"
                      id="guidelines"
                      placeholder="Enter  Guidelines"
                      #Guidelines
                    ></textarea>
                  </fieldset>
                  <fieldset class="form-group">
                    <label for="notes"> Notes </label>
                    <textarea
                      rows="1"
                      type="text"
                      class="form-control"
                      formControlName="notes"
                      [(ngModel)]="employee.notes"
                      id="notes"
                      placeholder="Enter  notes"
                      #notes
                    ></textarea>
                  </fieldset>
                  <fieldset class="form-group">
                    <label for="admin_notes"> Admin Notes </label>
                    <textarea
                      rows="1"
                      type="text"
                      class="form-control"
                      formControlName="admin_notes"
                      [(ngModel)]="employee.admin_notes"
                      id="admin_notes"
                      placeholder="Enter  Admin Notes"
                      #admin_notes
                    ></textarea>
                  </fieldset>

                  <!-- <fieldset class="form-group">
                      <label for="date">Date</label>
                      <input
                        type="date"
                        class="form-control"
                        formControlName="date"
                        [(ngModel)]="lead.date"
                        id="date"
                        placeholder="Enter date"
                      
  
                     #date />
                      <div
                        *ngIf="
                        rf.date.touched  && rf.date.errors?.required
                        "
                        class="help-block mt-1 text-danger"
                      >
                        <i class="ft-alert-circle align-middle"></i> Date 
                        is required
                      </div>
                    </fieldset> -->

                  <!-- <div class="form-group">
                    <label class="form-control-label mb-1" for="college">Status</label>
                    <fieldset class="position-relative has-icon-right">
                      <ng-select [items]="statusList" bindLabel="name" bindValue="value" placeholder="Select Satus"
                        [(ngModel)]="lead.status" [ngModelOptions]="{ standalone: true }"
                         #business="ngModel"> -->
                  <!-- <ng-template ng-label-tmp let-item="item">
                          <img height="15" width="15" [src]="item.avatar" />
                          <span [style.color]="!item.is_activated?'red':'black'">{{item.name}}</span>
                        </ng-template> -->
                  <!-- </ng-select>
                    </fieldset>
                    </div> -->
                  <div
                    class="col-12 d-flex flex-sm-row flex-column justify-content-end mt-3 mt-sm-2"
                  >
                    <button *ngIf="emp_id"
                      type="submit"
                      class="btn btn-primary mb-2 mb-sm-0 mr-sm-2"
                      [disabled]="!employeeForm.controls.name.valid || !employeeForm.controls.email.valid || !employeeForm.controls.phone.valid" (click)="submit()"
                    >
                      Submit
                    </button>
                    <button *ngIf="!emp_id"
                    type="submit"
                    class="btn btn-primary mb-2 mb-sm-0 mr-sm-2"
                    (click)="submit()"
                  >
                    Submit
                  </button>
                    <button
                      type="reset"
                      class="btn btn-secondary"
                      (click)="back()"
                    >
                      Cancel
                    </button>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</section>
